import React, { useEffect, useState } from 'react';
import { DashboardCategoryItem } from '../components/DashboardCategoryItem';
import { Dashboard } from '../interfaces/Dashboard';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { iconesMap } from '../lib/icones';
import Collapsible from '../components/Collapsible';
import Twitter from '../components/Twitter';

interface CategoryProps {
  title: string;
  dashboards: Dashboard[];
}

function Category({ title, dashboards }: CategoryProps) {
  const [busca, setBusca] = useState('');
  const [filteredDashboards, setFilteredDashboards] = useState<Dashboard[]>([]);

  useEffect(() => {
    const filtered = dashboards.filter(dashboard => {
      const regex = new RegExp(busca, 'i');
      const nameMachSearch = dashboard.name.match(regex)
      const tagsMachSearch = dashboard.tags.reduce((prev, current) => prev || !!current.match(regex), false)
      const descriptionMachSearch = dashboard.description.match(regex)
      return nameMachSearch || tagsMachSearch || descriptionMachSearch;
    }
    );
    setFilteredDashboards(filtered);
  }, [dashboards, busca]);

  // function handleInputChange(event: React.FormEvent<HTMLInputElement>) {
  //   event.preventDefault();
  //   setBusca(event.currentTarget.value);
  // }

  return (
    <div className='conteudo-home'>
      <main>
        <div className='categoria-header'>
          <div className="categoria-titulo">
            <span className='titulo-header'>Sala de situação</span>
            <h1>{title}</h1>
          </div>
          {/* <Collapsible title=""><Twitter/></Collapsible> */}
          {/* <div>
            <div className="categoria-container-busca input-group">
              <input
                type="text"
                className="busca"
                onChange={handleInputChange}
                value={busca}
                placeholder={`Buscar em ${title}`}
              />
              <div className="input-group-append">
                <FontAwesomeIcon icon={iconesMap["Busca"]} className="fa-xl" aria-hidden="true"/>
              </div>
            </div>
          </div> */}

        </div>
        <p className='contador-paineis'>
          <strong>{filteredDashboards.length}</strong> {filteredDashboards.length === 1 ? "painel encontrado." : "painéis encontrados."}
        </p>
        <div className="grid-4col">
          {filteredDashboards.map((dashboard) => (
            <div key={dashboard.urn} className="grid-item">
              <DashboardCategoryItem dashboard={dashboard} />
            </div>
          ))}
        </div>
      </main>
      <aside>
      </aside>
    </div>
  );
}

export default Category;
